import { useNavigate } from 'react-router-dom';
import { LazyPage } from '../components/loadable';
import { PlaceHolder } from '../components/place-holder';
import { useEffect } from 'react';


export * from './danh-muc';
export { default as HomePage } from './home/home';
export const LopBoMonPage = LazyPage(import('./lop-bo-mon'))
// export const LopMonHocPage = LazyPage(import('./lop-mon-hoc'))
export const LopMonHocLop = LazyPage(import('./lop-mon-hoc-lop'))
export const ConfigSoDiemTieuHocPage = LazyPage(import('./so-diem-tieu-hoc'))
export const GanSoDiemLayout = LazyPage(import('./gan-so-diem-layout'))
export const SoDiemLayout = LazyPage(import('./so-diem-layout'))

export const AppMenuTruongConfig = LazyPage(import('./app-phuhuynh/app-menu-truong'));
export const AppAccountPage = LazyPage(import('./app-phuhuynh/app-account'));
export const AppPhuHuynhLayout = LazyPage(import('./app-phuhuynh/AppPhuHuynhLayout'));
export const AppGiaoVienPage = LazyPage(import('./app-giaovien'));
export const AppGiaoVienLayout = LazyPage(import('./app-giaovien/AppGiaoVienLayout'));

export const BaiVietPage = LazyPage(import('./bai-viet'));
export const BaiVietDetailPage = LazyPage(import('./bai-viet/bai-viet-detail'));
export const AppXinNghiPage = LazyPage(import('./app-xinnghi'));
export const AppXinNghiDetailPage = LazyPage(import('./app-xinnghi/detail-page'));
// export const NhanXetHangNgayPage = LazyPage(import('./nhan-xet-hang-ngay'));
// export const NhanXetHangNgayCommentPage = LazyPage(import('./nhan-xet-hang-ngay/comment'));
export const BaiTapPage = LazyPage(import('./bai-tap'));
export const NhapDiemPage = LazyPage(import('./nhap-diem'));
export const LopHanhChinhList = LazyPage(import('./lop-hanh-chinh-list'));
export const LopHanhChinhPage = LazyPage(import('./lop-hanh-chinh'));

export const DiemVanMinhKetQuaPage = LazyPage(import('./diemvanminh/diemvanminh-ketqua'));
export const DiemVanMinhKetQuaPageBackup = LazyPage(import('./diemvanminh/diemvanminh-ketqua-backup'));
export const DiemVanMinhTieuChiPage = LazyPage(import('./diemvanminh/diemvanminh-tieuchi'));


export const GanSoNLPCPage = LazyPage(import('./gan-so-nlpc'));
export const DGDKNLPCPage = LazyPage(import('./danh-gia/dinh-ky/nlpc'));
export const DgTuanNlpcPage = LazyPage(import('./danh-gia/tuan/nlpc'));
export const ThoiKhoaBieuViewPage = LazyPage(import('./thoi-khoa-bieu/tkb-view'));
// export const ThoiKhoaBieuConfigPage = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-config'));
export const ThoiKhoaBieuImportPage = LazyPage(import('./thoi-khoa-bieu-danh-muc/ThoiKhoaBieuImportPage'));
export const ThoiKhoaBieuMamNonPage = LazyPage(import('./tkb-mam-non'));
// export const ThoiKhoaBieuImport = LazyPage(import('./thoi-khoa-bieu/thoi-khoa-bieu-import'));
export const BaoCaoTienBoPage = LazyPage(import('./bao-cao-tien-bo'));
export const XepHangHocSinhPage = LazyPage(import('./xep-hang-hoc-sinh'));

export const DanhGiaDinhKyLayout = LazyPage(import('./danh-gia/dinh-ky'));
// export const DanhGiaThuongXuyenLayout = LazyPage(import('./danh-gia/thuong-xuyen'));
// export const KhoaDanhGiaThuongXuyenPage = LazyPage(import('./danh-gia/khoa-thuong-xuyen'));
// export const BaoCaoDiemDanhPage = LazyPage(import('./bao-cao-diem-danh'));
// export const HocSinhProfilePage = LazyPage(import('./hoc-sinh'));
export const DangKyVeMuonPage = LazyPage(import('./dang-ky-ve-muon'));
export const DangKyVeMuonForm = LazyPage(import('./dang-ky-ve-muon/DangKyVeMuonForm'));

export const AppYeuCauHoTroPage = LazyPage(import('./app-phuhuynh/app_yeucauhotro'));
export const AppYeuCauHoTroDetailPage = LazyPage(import('./app-phuhuynh/app_yeucauhotro/detail-page/AppYeuCauHoTroDetailPage'));
export const BaiVietComment = LazyPage(import('./bai-viet/bai-viet-comment'));
export const BaoCaoTienBoReviewLayout = LazyPage(import('./bao-cao-tien-bo-review-layout'));
export const ClbNgoaiKhoaLayout = LazyPage(import('./clb-ngoai-khoa'));
export const ClbNgoaiKhoaDetail = LazyPage(import('./clb-ngoai-khoa/ClbNgoaiKhoaDetail'));
export const ClbNgoaiKhoaRegistedResult = LazyPage(import('./clb-ngoai-khoa/ClbNgoaiKhoaRegistedResult'));
export const DanThuocPage = LazyPage(import('./dan-thuoc'));
export const DanhGiaDinhKyHocTapPage = LazyPage(import('./danh-gia/dinh-ky/hoc-tap'));
export const ChieuCaoCanNangPage = LazyPage(import('./chieu-cao-can-nang'));
// export const DanhGiaThuongXuyenHocTapPage = LazyPage(import('./danh-gia/thuong-xuyen/hoc-tap'));
// export const DanhGiaThuongXuyenNLPCPage = LazyPage(import('./danh-gia/thuong-xuyen/nlpc'));
export const YeuCauHoTroGroupPage = LazyPage(import('./danh-muc/yeu-cau-ho-tro-group'));
export const DiemDanhHangNgay = LazyPage(import('./diem-danh-hang-ngay'));
export const MaNhanXetPage = LazyPage(import('./ma-nhan-xet'));
export const DiemDanhHangNgayPage = () => {
    console.log({
        DiemDanhHangNgayPage: "123"
    });

    const navigate = useNavigate();
    navigate(`../../diem-danh-hang-ngay/diem-danh`)
    useEffect(() => {
        navigate(`../../diem-danh-hang-ngay/diem-danh`)
    }, [])
    return (
        <PlaceHolder line_number={10} />
    );
}
export const NhanXetHangNgayPage = () => {
    const navigate = useNavigate();
    navigate(`../../diem-danh-hang-ngay/nhan-xet`)
    useEffect(() => {
        navigate(`../../diem-danh-hang-ngay/nhan-xet`)
    }, [])
    return (
        <PlaceHolder line_number={10} />
    );
}

export const PheDuyetDiemVanMinhPage = LazyPage(import('./diem-van-minh-phe-duyet'));
export const GanSoDiemPage = LazyPage(import('./gan-so-diem'));
export const SoDiemPage = LazyPage(import('./so-diem-trung-hoc'));

export const SurveyForm = LazyPage(import('./survey-form/SurveyForm'));
export const SurveyFormPage = LazyPage(import('./survey-form'));
export const SurveyLayout = LazyPage(import('./survey'));
export const SurveyRespone = LazyPage(import('./survey-respone'));
export const ThoiKhoaBieuConfigPage = LazyPage(import('./thoi-khoa-bieu-config'));

export const BaoCaoDiemDanhPage = LazyPage(import('./bao-cao-diem-danh'));
export const BaoCaoDiemDanhAnPage = LazyPage(import('./bao-cao-diem-danh-an'));
export const BaoCaoDiemDanhAnQuyetToanPage = LazyPage(import('./bao-cao-diem-danh-an-quyet-toan'));
export const BaoCaoNhapDiemPage = LazyPage(import('./bao-cao-nhap-diem'));
export const GioCongDongLayoutPage = LazyPage(import('./gio-cong-dong'));
export const GioCongDongHoatDongDetailPage = LazyPage(import('./gio-cong-dong/GioCongDongHoatDongDetailPage'));
export const HocSinhDashboardPage = LazyPage(import('./hoc-sinh-dashboard'));
export const CuocThaoLuanPage = LazyPage(import('./cuoc-thao-luan'));
export const LegalLayoutPage = LazyPage(import('./legal-document'));
export const AcceptionFormPage = LazyPage(import('./aception-form'));
export const LegalViewPage = LazyPage(import('./legal-document/view'));
export const DanhGiaThuongXuyenHocTapPage = LazyPage(import('./danh-gia/thuong-xuyen/hoc-tap'));
export const DotDanhGiaLayoutPage = LazyPage(import('./danh-gia/dot-danh-gia-layout'));
export const ThangDiemPage = LazyPage(import('./thang-diem-page'));
export const HoatDongHangNgayPage = LazyPage(import('./hoat-dong-hang-ngay'));
export const BaoCaoChamComPage = LazyPage(import('./ban-tru'));


